import React, { useState, useEffect } from 'react';
import { assistFormApiCall } from '../../cabsAPIs';

interface CouponData {
  couponCode: string;
  subTitle: string;
  title: string;
}

interface TripAssistantProps {
  trackEvent: (eventName: string) => void;
  autoOpenDelay: number;
  source?: string;
  destination?: string;
  couponData?: CouponData | null;
  showTripAssistant?: boolean;
  showLeaveIntentForm?: boolean;
  hideForm?: boolean;
  customerCareNumber?: string;
}

const TripAssistant = ({
  trackEvent,
  autoOpenDelay,
  source,
  destination,
  couponData,
  showTripAssistant,
  showLeaveIntentForm,
  customerCareNumber,
  hideForm = false
}: TripAssistantProps) => {
  const [formState, setFormState] = useState({
    isSubmitted: false,
    hasError: false
  });
  const [
    HelpFormComponent,
    setHelpFormComponent
  ] = useState<React.ComponentType<any> | null>(null);

  useEffect(() => {
    // @ts-ignore - Dynamic import not supported by current tsconfig module setting
    import('@gommt-cabs/ui-lib').then(module => {
      setHelpFormComponent(() => module.HelpForm);
    });
  }, []);

  const formSubmitCall = async (phoneNumber: string) => {
    const assistedFormRequest = {
      source: source || '',
      destination: destination || '',
      travel_date: '',
      name: '',
      mobile: phoneNumber,
      special_request: '',
      type: 'seoAssistedFlowRequest'
    };

    try {
      const response = await assistFormApiCall(assistedFormRequest);
      if (response['errors']) {
        setFormState({
          isSubmitted: true,
          hasError: true
        });
      } else {
        setFormState({
          isSubmitted: true,
          hasError: false
        });
      }
    } catch (error) {
      setFormState({
        isSubmitted: true,
        hasError: true
      });
    }
  };

  if (!HelpFormComponent) {
    return null;
  }

  return (
    <HelpFormComponent
      trackEvent={trackEvent}
      onSubmit={formSubmitCall}
      formState={formState}
      hideForm={hideForm}
      setFormState={setFormState}
      pageName="SEO"
      autoOpenDelay={autoOpenDelay}
      couponInfo={couponData}
      showAssistantIcon={showTripAssistant}
      showLeaveIntentForm={showLeaveIntentForm}
      customerCareNumber={customerCareNumber}
    />
  );
};

export default TripAssistant;
